<template>
  <div class="cloudupload-dialog-modal">
    <div class="cloudupload_dialog">
      <div class="cloudupload-dialog-head">
        上传云文件
      </div>
      <div class="cloudupload-dialog-body">
        <div class="up-content-option">
          <div class="up-content-option_list top-box">
            <div>
              <template v-if="+user.userType === 3">
                <!--<a  class="ui-btn" :class="+activeIndex === 1 ? 'ui-btn_blue' : ''" @click="itemTap(1)"><i class="w-icon-gerenkongjian1"></i>员工资料库</a>-->
                <!--<a  class="ui-btn" :class="+activeIndex === 2 ? 'ui-btn_blue' : 'btn-icon-style1'" @click="itemTap(2)"><i class="w-icon-qiyekongjian1"></i>企业共享空间</a>-->
                <w-button :type="+activeIndex === 1 ? 'primary' : 'default'" @click="itemTap(1)"><i
                  class="w-icon-gerenkongjian1"></i><span>员工资料库</span>
                </w-button>
                <w-button :type="+activeIndex === 2 ? 'primary' : 'default'" @click="itemTap(2)"><i
                  class="w-icon-qiyekongjian1"></i><span>企业共享空间</span>
                </w-button>
              </template>
              <template v-else>
                <!--<a  class="ui-btn ui-btn_blue" v-if="+user.userType === 2"><i class="w-icon-gerenkongjian1"></i>个人空间</a>-->
                <!--<a  class="ui-btn ui-btn_blue" v-else><i class="w-icon-qiyekongjian1"></i>企业共享空间</a>-->
                <w-button type="primary" v-if="+user.userType === 2" @click="itemTap(1)"><i
                  class="w-icon-gerenkongjian1"></i><span>个人空间</span>
                </w-button>
                <w-button type="primary" v-else @click="itemTap(2)"><i class="w-icon-qiyekongjian1"></i><span>企业共享空间</span>
                </w-button>
              </template>
            </div>
            <!-- 搜索 -->
            <operation-search class="float_right" @onSearch="searchHandle"></operation-search>
          </div>
          <div class="up-content-option_list top-box-border">
            <!-- 面包屑 -->
            <operation-crumb :items="pathItems" @change="queryPathList">
            </operation-crumb>
          </div>
          <div class="tabcnt">
            <Table :height="totalCount > pageSize ? 240 : 290">
              <thead slot="header">
                <tr>
                  <th class="checkAllth">
                    <label class="checkall-label">
                      <w-checkbox v-model="isCheckAll" @change="checkAll">全选</w-checkbox>
                      <!--<input type="checkbox" @click="checkAll" readonly :checked="isCheckAll"/> 全选-->
                    </label>
                    <span class="check-length"></span>
                    <span class="person-sort">名称</span>
                  </th>
                  <th width="80">文件类型</th>
                  <th width="120">类型</th>
                  <th width="110">
                    <span class="person-sort">
                      修改时间
                    </span>
                  </th>
                  <th width="110">
                    <span class="person-sort">
                      文件大小
                    </span>
                  </th>
                  <th width="5" v-if="dataList.length > 5"></th>
                </tr>
              </thead>
              <tbody slot="body">
              <tr v-for="(item,index) in dataList"
                  :key="index"
                  height="40"
                  @click="trClick(index)"
                  :class="item.checked ? 'active trItem' : 'trItem'">
                <td>
                  <div class="l-boxd">
                    <label class="w__checkbox" style="margin-right: 0;" :class="{'is-checked': item.checked}">
                      <span class="w__checkbox__input" :class="{'is-checked': item.checked}">
                        <span class="w__checkbox__inner" @click.stop=""></span>
                        <input type="checkbox" class="w__checkbox__original">
                      </span>
                    </label>
                    <!--<input type="checkbox" :checked="item.checked" readonly/>-->
                    <div class="personHover l-boxd-d">
                      <!-- <i class="file-icons" :class="'file-'+item.icons"></i> -->
                      <i
                        :class="['file-icons', 'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? 'folder': '']"></i>
                      <span class="file-name cloudupload-file-name"
                            v-on:click.stop="nameClick(item)">{{item.name}}</span>
                    </div>
                  </div>
                </td>
                <td width="80" align="center">{{item.extraInfoStr}}</td>
                <td width="120" align="center">{{formatPorojectType(item.fileProperties.projectType)}}</td>
                <td width="110" align="center">{{item.modifyTime}}</td>
                <td width="110" align="center"><span v-if="!item.folder">{{item.length | formatSizeFilter()}}</span>
                </td>
              </tr>
              </tbody>
            </Table>
          </div>
          <div class="pages-box" v-if="totalCount > pageSize">
            <w-pagination
              background
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
              :pageSize="pageSize"
              :total="totalCount">
            </w-pagination>
          </div>
        </div>
      </div>
      <div class="cloudupload-dialog-foot">
        <w-button type="primary" @click.stop.prevent="affirm">打开</w-button>
        <w-button @click.stop.prevent="cancle">取消</w-button>
        <!--<input class="ui-btn" type="button" value="打开" @click="affirm">-->
        <!--<input class="ui-btn" type="button" value="取消" @click="cancle">-->
      </div>
    </div>
  </div>
</template>
<script>
// import { backendUrl } from '@/assets/js/config';
// import Bus from '@/assets/utils/bus';
import {formatDay, capitalize} from '@/assets/utils'
import Table from '_c/common/Table/Index.vue'
// import { mapState, mapMutations  } from 'vuex';
import {getCookie} from '@/assets/utils/CommonUtil'
import {getFileTyeIconClass} from '@/assets/utils/space'
import SpaceService from '@/assets/service/space'
import {OperationCrumb, OperationSearch} from '@/components/common'
// let projectType = {
//   1000: "概算项目工程",
//   1100: "概算清单项目工程",
//   2100: "清单计价单位工程",
//   2600: "清单计价单位工程",
//   "2100,2600": "清单计价单位工程",
//   2200: "定额计价单位工程",
//   2300: "招标项目工程",
//   2400: "投标项目工程",
//   2500: "预算项目工程",
//   3300: "验工计价工程",
//   3400: "结算计价工程",
//   4000: "概算审核项目工程",
//   4050: "结算审核工程",
//   4100: "清单计价审核单位工程",
//   4150: "定额计价审核单位工程",
//   4200: "招标项目审核工程",
//   4250: "投标项目审核工程",
//   4300: "预算项目审核工程",
// }
let projectType = {}

function initProjectTypeMap () {

  projectType['1000'] = '概算工程'
  projectType['1100'] = '概算清单工程'

  projectType['2000'] = '预算工程'
  projectType['2100'] = '清单计价单位工程'
  projectType['2200'] = '定额计价单位工程'
  projectType['2300'] = '招标工程'
  projectType['2400'] = '投标工程'
  projectType['2500'] = '预算工程'

  projectType['3300'] = '验工计价工程'
  projectType['3400'] = '结算计价工程'

  projectType['4000'] = '概算审核工程'
  projectType['4050'] = '结算审核工程'
  projectType['4100'] = '清单计价审核单位工程'
  projectType['4150'] = '定额计价审核单位工程'
  projectType['4200'] = '招标审核工程'
  projectType['4250'] = '投标审核工程'
  projectType['4300'] = '预算审核工程'

  return projectType
}

initProjectTypeMap()
export default {
  components: {
    Table,
    OperationCrumb,
    OperationSearch
  },
  data () {
    return {
      activeIndex: 1,
      searchVal: '',
      sortType: 1,
      sortFieldName: 'modifiedTime',
      path: '/',
      pageNum: 1,
      pageSize: 20,
      isCheckAll: false,
      dataList: [],
      pathItems: [
        {
          name: '全部文件'
        }
      ],
      totalCount: 0,
      state: {}
    }
  },
  props: {
    tabletype: {
      type: String
    }
  },
  methods: {
    // 将 val 全部转换成小写
    capitalize (val) {
      return capitalize(val, true, true)
    },
    formatPorojectType (type) {
      console.log(type)
      return (projectType[type] || '')
    },
    itemTap (val) {
      this.activeIndex = val
      this.pageNum = 1
      this.pageSize = 20
      this.totalCount = 0
      this.searchVal = ''
      this.pathItems = [
        {
          name: '全部文件'
        }
      ]
      this.path = '/'
      initData(this)
    },
    affirm () {
      let selList = this.dataList.filter((item) => item.checked)
      let folderList = selList.filter((sitem) => sitem.folder)
      if (selList.length === 0) {
        return
      }
      if (folderList.length > 0) {
        this.$message.warning('所选工程不能包含文件夹！')
        return
      }
      let errorText = ''
      selList.map((item) => {
        if (item.suffix) {
          // |GZB4|GTB4
          let reg = /GBQ5|GPB5|GPV5|GSC5|GSH5|GBQ6|GPB6|GPV6|GSC6|GSH6|GBQ7|GPB7|GPV7|GSC7|GSH7$/ig
          let suffix = item.suffix.toUpperCase()
          if (!reg.test(suffix)) {
            // ,GZB4,<br/>GTB4
            errorText = '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程'
          }
        }
      })
      if (errorText) {
        this.$confirm({
          message: errorText,
          noCancelBtn: true,
          width: 490
        })
        return
      }
      this.$emit('affirm', selList, getWorkspaceId(this))
    },
    cancle () {
      this.$emit('cancle')
    },
    handleCurrentChange (val) {
      this.pageNum = val
      initData(this)
    },
    searchHandle (val) {
      console.log(val)
      this.searchVal = val
      initData(this)
    },
    // 面包屑点击
    queryPathList (data) {
      console.log(data.filepath)
      if (data.filepath === '/全部文件') {
        this.path = '/'
        this.pathItems = [{name: '全部文件'}]
      } else {
        this.path = data.filepath
        this.pathItems = data.items
      }
      initData(this)
    },

    // 名称点击
    nameClick (item) {
      console.log(item)
      // 进入文件夹
      if (item.folder) {
        this.path = item.path
        this.pathItems.push({
          name: item.name
        })
        initData(this)
      }
    },
    // 单行选中
    trClick (index) {
      let dataobj = {...this.dataList[index]}
      dataobj.checked = !dataobj.checked
      this.dataList.splice(index, 1, dataobj)
    },
    // 全选
    checkAll () {
      // this.isCheckAll = !this.isCheckAll
      let dataList = [...this.dataList]
      dataList = dataList.map((item) => {
        item.checked = this.isCheckAll
        return {
          ...item
        }
      })
      this.dataList = dataList
    }
  },
  destroyed () {

  },
  mounted () {

  },
  created () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    initData(this)
  }
}

// 获取空间id
function getWorkspaceId (that) {
  if (+that.user.userType === 2 || (+that.user.userType === 3 && +that.activeIndex === 1)) {
    return getCookie('personalWorkspaceIdValue')
  } else if (+that.user.userType === 1 || (+that.user.userType === 3 && +that.activeIndex === 2)) {
    return getCookie('enterpriseWorkspaceIdValue')
  }
  console.log('----------------')
}

// 初始化数据
function initData (that) {
  console.log(that)
  let parameter = {
    path: that.path,
    workspaceId: getWorkspaceId(that),
    fileType: 1,
    sortFieldName: that.sortFieldName,
    sortType: that.sortType,
    pageNum: that.pageNum,
    pageSize: that.pageSize,
    suffixs: 'GBQ5,GPB5,GPV5,GSC5,GSH5,gbq5,gpb5,gpv5,gsc5,gsh5,GBQ6,GPB6,GPV6,GSC6,GSH6,gbq6,gpb6,gpv6,gsc6,gsh6,GBQ7,GPB7,GPV7,GSC7,GSH7,gbq7,gpb7,gpv7,gsc7,gsh7'
  }
  let apiName = 'getFileList'
  if (that.searchVal) {
    apiName = 'getSearchFileList'
    parameter.searchCondition = `{
        name: ${that.searchVal}
      }`
  }
  that.renameData = {
    value: '',
    showIndex: -1
  }
  SpaceService[apiName](parameter).then((res) => {
    console.log('getFileList====>', res)
    if (+res.code === 200) {
      if (res.data.items) {

        res.data.items.forEach((item) => {
          // item.size = sizeConver(item.length);
          if (item.createTime) {
            item.createTime = formatDay(new Date(parseInt(item.createTime)))
          }
          if (item.modifyTime) {
            item.modifyTime = formatDay(new Date(parseInt(item.modifyTime)))
          }
          let extraInfoStr = ''
          let extraInfo = 0
          let proT = item.fileProperties.projectType
          if (proT >= 4000) {
            extraInfo = 4
            extraInfoStr = '审核'
          } else if (proT >= 3000) {
            extraInfo = 3
            extraInfoStr = '结算'
          } else if (proT >= 2000) {
            extraInfo = 2
            extraInfoStr = '预算'
          } else if (proT >= 1000) {
            extraInfo = 1
            extraInfoStr = '概算'
          } else {
            extraInfo = 0
            extraInfoStr = '其它'
          }
          item.extraInfo = extraInfo
          item.extraInfoStr = extraInfoStr
        })
        that.isCheckAll = false
        that.dataList = getFileTyeIconClass(res.data.items)
        that.totalCount = res.data.totalCount
      }
    }
  })
}


</script>
<style lang="less" scoped>
  @import "~@/components/common/ProjectTable/Index.less";
  /*@import "./Index.less";*/
</style>
<style lang="less">
  .cloudupload-dialog-modal {
    .cloudupload_dialog {
      border-radius: 4px;
    }

    .table-wrapper .table-head-wrapper {
      margin-right: 0px;
    }

    table {
      table-layout: fixed;

      .cloudupload-file-name {
        white-space: normal;
        max-width: calc(100% - 70px);
      }
    }
  }

</style>

